import React, { useState } from "react";
import { MoveReviewImg, VariationSectionImg } from "../../assets";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { EngineCard, Sparkels } from "../../Components";
import { Explore } from "..";

const Features = (props) => {

    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
      });
    
    return (
      <div >
      <div className={`${styles["hero-spacer"]}`} />
      <div
        key={scrollPos}
        className={`${styles["content-section"]}`}
      >
        <h3 className={`${styles.title}`}>
          Accurate Realtime Move Review
        </h3>
        <Sparkels />
        <p className={`${styles.subp} pb-5`}>
          You can choose to display move review sticker to grade your move. This works even without analysing in case we have a cloud analysis available for the position. You are also free to place the stickers yourself and they are saved with your variation so you can always go back and see them.
        </p>
        <div className="w-full flex items-center justify-center">
        <div className={`${styles.imgContainer} flex items-center justify-center w-[40%] min-w-[350px] py-[3%]`}>
        <img src={MoveReviewImg} className="rounded w-[95%]"/>
        </div>
        </div>
      </div>
        </div>
    )
}

export default Features;